<template>
    <div class="row market-rowFx">
        <div class="control-sectionFXfuture">
            <h5 id="powerTitleFx">FX&Indices</h5>
            <div class="form-row form-row-Fx">
                <div class="form-group col-md-2 col-md-2Fxbtn">
                    <ejs-button id="btn-marketOil" v-on:click.native='getOtherRates'>Oil</ejs-button>
                </div>
                <div class="form-group col-md-3 col-md-2Fxbtn">
                    <ejs-button id="btn-marketEua" v-on:click.native='getOtherRates'>EUA Cert.</ejs-button>
                </div>
                <div class="form-group col-md-2 col-md-2Fxbtn">
                    <ejs-button id="btn-marketFx" v-on:click.native='getOtherRates'>FX</ejs-button>
                </div>
                <div class="form-group col-md-3 col-md-2Fxbtn">
                    <ejs-button id="btn-marketInd" v-on:click.native='getOtherRates'>Indices</ejs-button>
                </div>
                <div class="form-group col-md-2 col-md-2Fxbtn">
                    <ejs-button id="btn-marketOth" v-on:click.native='getOtherRates'>Other</ejs-button>
                </div>
            </div>
            <div class="chartFx" align='center'>
                <ejs-stockchart id="stockchartcontainer"
                                height='450px'
                                width="83%"
                                :primaryXAxis="primaryXAxis"
                                :primaryYAxis="primaryYAxis"
                                :crosshair="crosshair"
                                :title="title"
                                :tooltip="tooltip"
                                :enableSelector="enableSelector"
                                :trendlineType="trendlineType"
                                :indicatorType="indicators"
                                :seriesType="seriesType"
                                :theme="theme">
                    <e-stockchart-periods>
                        <e-stockchart-period intervalType="Months" interval="1" text="1M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Months" interval="3" text="3M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Months" interval="6" text="6M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Years" interval="1" text="1Y" selected="true"></e-stockchart-period>
                        <e-stockchart-period text="YTD"></e-stockchart-period>
                        <e-stockchart-period text="All"></e-stockchart-period>
                    </e-stockchart-periods>
                    <e-stockchart-series-collection>
                        <e-stockchart-series :dataSource="seriesDataFx" type="Spline" xName='date' yName="price" fill="#485696"></e-stockchart-series>
                    </e-stockchart-series-collection>
                </ejs-stockchart>
            </div>
            <div id="fxMarket" class="power-marketFx">
                <ejs-tooltip ref="tooltip" target=".e-rowcell" :beforeRender="beforeRender">
                    <ejs-grid id="fxMarketGrid"
                              :dataSource="fxRates"
                              ref="fxMarketRatesGrid"
                              class="fx-rates"
                              :allowPaging="true"
                              :allowRowDragAndDrop="false"
                              :selectionSettings="selection"
                              :queryCellInfo='customiseCell'
                              :pageSettings='pageSettings'
                              :rowDataBound="rowDataBound"
                              :rowSelected='rowSelected'
                              :toolbarClick='toolbarClickFxr'
                              :toolbar='toolbarOptionsFxr'
                              :selectedRowIndex=0>
                        <e-columns>
                            <e-column field='id' :disableHtmlEncode='false' headerText='Id' :width="100" :visible="false" textAlign='Left'></e-column>
                            <e-column field='flag' :disableHtmlEncode='false' headerText='' textAlign='Left' :valueAccessor="valueAccessCurrency" width="40px"></e-column>
                            <e-column field='name' :disableHtmlEncode='false' headerText='' textAlign='Left'></e-column>
                            <e-column field='description' :disableHtmlEncode='false' headerText='Description' textAlign='Left' :visible="false"></e-column>
                            <e-column field='newRate' :disableHtmlEncode='false' headerText='' textAlign='Center'></e-column>
                            <e-column field='difference' :disableHtmlEncode='false' headerText='' textAlign='Center'></e-column>
                            <e-column field='percentageDiff' headerText='' :disableHtmlEncode='false' textAlign='Center'></e-column>
                        </e-columns>
                    </ejs-grid>
                    </ejs-tooltip>
            </div>
                <div id="hiddenDivFxr" style="display: none;" class="__web-inspector-hide-shortcut__">
                    <ejs-grid id="chartHiddendataFxr"
                              :dataSource="chartHiddenSourceFxr"
                              ref="chartHiddenGridFxr"
                              :allowPaging="true"
                              :pageSettings='pageSettings'
                              :allowExcelExport='true'
                              :visible="false">
                        <e-columns>
                            <e-column field='id' :disableHtmlEncode='false' headerText='Id' :isPrimaryKey='true' :visible="false" textAlign='Left'></e-column>
                            <e-column field='currencyConversionName' :disableHtmlEncode='false' headerText='Ric' textAlign='Left' width="100px"></e-column>
                            <e-column field='currencyConversionFrom' :disableHtmlEncode='false' headerText='Currency From' textAlign='Left' width="120px"></e-column>
                            <e-column field='currencyConversionTo' :disableHtmlEncode='false' headerText='Currency To' textAlign='Left' width="120px"></e-column>
                            <e-column field='price' :disableHtmlEncode='false' headerText='Price' textAlign='Left' width="120px"></e-column>
                            <e-column field='date' :disableHtmlEncode='false' headerText='Date' type="date" :format='dateFormatOptions' textAlign='Left' width="120px"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                <div id="hiddenDivOther" style="display: none;" class="__web-inspector-hide-shortcut__">
                    <ejs-grid id="chartHiddendataOth"
                              :dataSource="chartHiddenSourceOth"
                              ref="chartHiddenGridOth"
                              :allowPaging="true"
                              :pageSettings='pageSettings'
                              :allowExcelExport='true'
                              :visible="false">
                        <e-columns>
                            <e-column field='id' :disableHtmlEncode='false' headerText='Id' :isPrimaryKey='true' :visible="false" textAlign='Left'></e-column>
                            <e-column field='name' :disableHtmlEncode='false' headerText='Ric' textAlign='Left' width="100px"></e-column>
                            <e-column field='description' :disableHtmlEncode='false' headerText='Description' textAlign='Left' width="400px"></e-column>
                            <e-column field='utilityTypeName' :disableHtmlEncode='false' headerText='Category' textAlign='Left' width="120px"></e-column>
                            <e-column field='date' :disableHtmlEncode='false' headerText='Date' type="date" :format='dateFormatOptions' textAlign='Left' width="120px"></e-column>
                            <e-column field='price' :disableHtmlEncode='false' headerText='Price' textAlign='Left' width="120px"></e-column>
                            <e-column field='tradingUnitPreview' :disableHtmlEncode='false' headerText='Trading Unit' textAlign='Left' width="120px"></e-column>

                        </e-columns>
                    </ejs-grid>
                </div>
        </div>
        </div>
    
</template>
<script>
    import Vue from "vue";

    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import { GridPlugin, Page, Selection, RowDD, Toolbar, ExcelExport } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import apis from '@/common/network';
    import urls from '@/common/urls';
    import dates from '@/common/dates';
    import {
        StockChartPlugin, DateTime, CandleSeries, RangeTooltip, LineSeries, SplineSeries,
        HiloOpenCloseSeries, HiloSeries, RangeAreaSeries, Trendlines, EmaIndicator, RsiIndicator, BollingerBands,
        TmaIndicator, MomentumIndicator, SmaIndicator, AtrIndicator, Crosshair, AccumulationDistributionIndicator, MacdIndicator, StochasticIndicator, Export, Tooltip
    } from "@syncfusion/ej2-vue-charts";
    import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";
    import { getCurrencyFlagHtml } from '@/common/flags';

    Vue.use(StockChartPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(TooltipPlugin);

    let selectedTheme = location.hash.split("/")[1];
    selectedTheme = selectedTheme ? selectedTheme : "Material";
    let theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark");

    export default Vue.extend({
        data: function () {
            return {
                fxDateVal: dates.addDays(new Date(), -7),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                fxRates: [],
                fxRatesNew: [],
                powerRates: [],
                seriesDataFx: [],
                oilRates: [],
                euaCertRates: [],
                indicesRates: [],
                otherRates: [],
                chartHiddenSourceFxr: [],
                chartHiddenSourceOth:[],
                toolbarOptionsFxr: ['Export Data'],
                selection: { type: 'Multiple' },
                theme: theme,
                pageSettings: { pageSize: 8 },
                //Initializing Primary X Axis
                primaryXAxis: {
                    visible: true,
                    valueType: 'DateTime',
    
                },
                //Initializing Primary Y Axis
                primaryYAxis:
                {
                    visible: true,
                    majorTickLines: { color: "transparent", width: 0 },


                },

                enableSelector: true,
                trendlineType: [],
                indicators: [],
                seriesType: [],
                theme: 'Bootstrap',
                tooltip: {
                    enable: true, header: ' ',
                    format: '<b>${point.x} : ${point.y}</b>'
                },
                crosshair: { enable: true },
                chartArea: {
                    border: {
                        width: 0
                    }
                },
/*                width: '450px',*/
                height: '250px',
                title: " ",
                palettes: ["#001c55", "#4d4d4d"]
  
            };
        },
        created() {
 
            this.fetchFxRatesData();
            this.fetchOtherData();

        },
        provide: {
            stockChart: [
                DateTime, Crosshair, RangeTooltip, LineSeries, SplineSeries, CandleSeries, HiloOpenCloseSeries, HiloSeries, RangeAreaSeries, Trendlines, EmaIndicator, RsiIndicator,
                BollingerBands, TmaIndicator, MomentumIndicator, SmaIndicator, AtrIndicator, AccumulationDistributionIndicator, MacdIndicator, StochasticIndicator, Export, Tooltip
            ],
            grid: [Page, Selection, RowDD, Toolbar, ExcelExport]
        },
        mounted() {
         
            
        },
        methods: {
            //toolTip for Other 
            beforeRender: function (args) {
                var cellIndex = parseInt(args.target.closest('.e-rowcell').getAttribute('aria-colindex'));
                var column = this.$refs.fxMarketRatesGrid.ej2Instances.getColumnByIndex(cellIndex);
                if (this.$refs.chartHiddenGridOth.dataSource.length > 0) {
                    if (column.field == "newRate" || column.field == "difference" || column.field == "percentageDiff" || column.field == "flag") {
                        args.cancel = true;

                    } else {
                        var othColumn = this.$refs.fxMarketRatesGrid.getCurrentViewRecords();
                        var item = "";
                        for (var i = 0; i < othColumn.length; i++) {
                            if (othColumn[i].name == args.target.innerText) {
                                item = othColumn[i].description;
                            }
                        }
                        this.$refs.tooltip.content = item;
                    }
                } else {
                    if (column.field == "name" || column.field == "newRate" || column.field == "difference" || column.field == "percentageDiff" || column.field == "flag") {
                        args.cancel = true;

                    }
                }
            },

            toolbarClickFxr: function (args) {

                if (args.item.id === 'fxMarketGrid_Export Data') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name

                    let excelExportProperties = {
                        fileName: "Export Chart FX&Indices.xlsx",
                        theme:
                        {
                            header: {
                                fontName: 'Arial', fontColor: '#001c55'
                            },
                            record: {
                                fontName: 'Arial', fontColor: '#4d4d4d'
                            },
                            caption: {
                                fontName: 'Arial', fontColor: '#4d4d4d'
                            }
                        }
                    };

                    if (this.$refs.chartHiddenGridFxr.dataSource.length > 0) {

                        this.$refs.chartHiddenGridFxr.excelExport(excelExportProperties);
                    }
                    if (this.$refs.chartHiddenGridOth.dataSource.length > 0) {

                        this.$refs.chartHiddenGridOth.excelExport(excelExportProperties);
                    }
                    
                  
                }
            },
            valueAccessCurrency: function (field, data, column) {
                return getCurrencyFlagHtml(data); // Make sure to return!
            },

            rowSelected: function (args) {
                if (args.data.utilityTypeName != null) {
                    this.fetchOtherChart(args.data.id);
                } else {
                    this.fetchFxRatesDataChart(args.data.id);
                }
            },
            rowDataBound: function (args) {

                if (args.row.ariaRowIndex == "0") {

                    if (args.data.utilityTypeName != null) {
                        this.fetchOtherChart(args.data.id);
                    } else {
                        this.fetchFxRatesDataChart(args.data.id);
                    }
                   
                }
         
            },
            getOtherRates: function (args) {
                if (args.currentTarget.textContent == "Oil") {

                    this.fxRates = this.oilRates;

                }
                if (args.currentTarget.textContent == "EUA Cert.") {

                    this.fxRates = this.euaCertRates;
                }
                if (args.currentTarget.textContent == "FX") {

                    this.fxRates = this.fxRatesNew;

                }

                if (args.currentTarget.textContent == "Indices") {

                    this.fxRates = this.indicesRates;
                }
                if (args.currentTarget.textContent == "Other") {

                    this.fxRates = this.otherRates;
                }

            },
            customiseCell: function (args) {

                if (args.data.difference > 0) {
                    if (!args.data.difference.includes("+") && !args.data.percentageDiff.includes("+")) {
                        args.data.difference = "+" + args.data.difference;
                        args.data.percentageDiff = "+" + args.data.percentageDiff + "%";
                    }
                    args.cell.classList.add("above-0");

                } else if (args.data.difference < 0) {
                    args.cell.classList.add("below-0");

                    if (!args.data.difference.includes("%") && !args.data.percentageDiff.includes("%")) {
                        var item = args.data.percentageDiff + "%";
                        args.data.percentageDiff = item;
                    }
                  

                } else {
                  
                    args.cell.classList.add('same-0');
                    if (!args.data.difference.includes("%") && !args.data.percentageDiff.includes("%")) {
                        var item = args.data.percentageDiff + "%";
                        args.data.percentageDiff = item;
                    }
                 
                }
            },
            groupBy(arr, keyFunction) {
                const groups = {};
                arr.forEach(function (el) {
                    const key = keyFunction(el);
                    if (key in groups === false) {
                        groups[key] = [];
                    }
                    groups[key].push(el);
                });
                return groups;
            },
            // if diff is a positive number, it's an increase, otherwise it's a decrease
            calculatePercentageDiff(oldValue, newValue) {
                var diff = newValue - oldValue;
                return (diff / oldValue) * 100;
            },

            getFieldName: function (fieldName, data) {
                if (fieldName === "name") {
                    return data.name
                } else if (fieldName === "difference") {
                    return data.difference;
                } else if (fieldName === "percentageDiff") {
                    return data.percentageDiff + " " + "%";
                } else if (fieldName === "id") {
                    return data.id;
                } else if (fieldName === "newRate") {
                    return data.newRate;
                }
            },
            checkPermissionOnUser: function () {

                if (!this.$store.state.permissions["Permissions.MarketWidgetsAndGraphs.Update"]) {

                       this.$refs.fxMarketRatesGrid.ej2Instances.toolbarModule.toolbar.element.hidden = true;
                  }
             
            },
            fetchFxRatesDataChart(id) {
                apis.protectedApi(`${urls.apiBaseUrl}FXRate/FromDateChart?date=${this.fxDateVal.toISOString().split('T')[0]}&id=${id}`).then(fxr => {
                    let temp = [];
                    let tempChartFxr = [];
                    for (var i = 0; i < fxr.data.result.length; i++) {
                        tempChartFxr.push(fxr.data.result[i]);

                        let fxrRateChart = {
                            id: fxr.data.result[i].id,
                            currencyConversionName: fxr.data.result[i].currencyConversionName,
                            currencyConversionFrom: fxr.data.result[i].currencyConversionFrom,
                            currencyConversionTo: fxr.data.result[i].currencyConversionTo,
                            price: fxr.data.result[i].price.toFixed(4),
                            date: new Date(fxr.data.result[i].date)

                        }
                        temp.push(fxrRateChart);
                    }
                   
                    this.seriesDataFx = tempChartFxr;
                    this.chartHiddenSourceOth = [];
                    this.chartHiddenSourceFxr = temp;
           
           
                }).catch(
                    //response => { this.handleError(response); }
                );



            },
            //This calls only FxRates 
            fetchFxRatesData() {
      
                apis.protectedApi(`${urls.apiBaseUrl}FXRate/FromDate?date=${this.fxDateVal.toISOString().split('T')[0]}`).then(fxr => {
                    let temp = [];
                    let fxrGrouped = this.groupBy(fxr.data.result, fx => fx.currencyConversionId);
                    const fxrArray = Object.keys(fxrGrouped).map(id => {
                      
                        return {
                     
                            id,
                            fxrGroups: fxrGrouped[id]
                        }
                    });
                    for (const fxrObj of fxrArray) {
                        if (fxrObj.fxrGroups.length >= 2) {
                            let oldFxRate = fxrObj.fxrGroups[fxrObj.fxrGroups.length - 2];
                            let newFxRate = fxrObj.fxrGroups[fxrObj.fxrGroups.length - 1];
                            let fxRate = {
                                id: newFxRate.currencyConversionId,
                                name: newFxRate.currencyConversionFrom + '-' + newFxRate.currencyConversionTo,
                                difference: (newFxRate.rate - oldFxRate.rate).toFixed(4),
                                newRate: newFxRate.rate.toFixed(4),
                                date: newFxRate.date,
                                percentageDiff: (this.calculatePercentageDiff(oldFxRate.rate, newFxRate.rate)).toFixed(2),
                                utilityTypeName: null
                                
                            }
                            temp.push(fxRate);
                        }
                    }


                    this.fxRates = temp;
                    this.fxRatesNew = temp;
                    this.checkPermissionOnUser();

                }).catch(
                    //response => { this.handleError(response); }
                );
            },


            fetchOtherChart(ricId) {
                apis.protectedApi(`${urls.apiBaseUrl}otherMarketInstruments/FromDateChart?date=${this.fxDateVal.toISOString().split('T')[0]}&ricId=${ricId}`).then(oth => {
                    let temp = [];
                    let tempChartOther = [];
                    for (var i = 0; i < oth.data.result.length; i++){
                        temp.push(oth.data.result[i]);

                        let otherChartRate = {
                            id: oth.data.result[i].ricId,
                            name: oth.data.result[i].ricName,
                            description: oth.data.result[i].description,
                            utilityTypeName: oth.data.result[i].utilityTypeName,
                            price: oth.data.result[i].price.toFixed(4),
                            date: new Date(oth.data.result[i].date),
                            tradingUnitPreview: oth.data.result[i].tradingUnitPreview
                            

                        }
                        tempChartOther.push(otherChartRate);
                    }
                    this.seriesDataFx = temp;
                    this.chartHiddenSourceFxr = [];
                    this.chartHiddenSourceOth = tempChartOther;
                });

                
            },

            //This calls all other ric, like Equity, Coal, Carbon but there is another way for sorting these things;
            //Oil is oil, EUA Cert. is Carobn, Indices is Equity, and everything else is Other
            fetchOtherData() {
                apis.protectedApi(`${urls.apiBaseUrl}otherMarketInstruments/FromDate?date=${this.fxDateVal.toISOString().split('T')[0]}`).then(oth => {
                    let temp = [];

                    let othGrouped = this.groupBy(oth.data.result, ot => ot.ricId);
                    const othArray = Object.keys(othGrouped).map(id => {

                        return {

                            id,
                            othGroups: othGrouped[id]
                        }
                    });


                    for (const othObj of othArray) {
                        if (othObj.othGroups.length >= 2) {
                            let oldOtherRate = othObj.othGroups[othObj.othGroups.length - 2];
                            let newOtherRate = othObj.othGroups[othObj.othGroups.length - 1];
                            let otherRate = {
                                id: newOtherRate.ricId,
                                name: newOtherRate.ricName,
                                difference: (newOtherRate.price - oldOtherRate.price).toFixed(4),
                                newRate: newOtherRate.price.toFixed(4),
                                percentageDiff: (this.calculatePercentageDiff(oldOtherRate.price, newOtherRate.price)).toFixed(2),
                                utilityTypeName: newOtherRate.utilityTypeName,
                                date: newOtherRate.date,
                                description: newOtherRate.description

                            }
                            temp.push(otherRate);
                        }


                    }
                    //This is for sorting what is what for grid 
                    for (var i = 0; i < temp.length; i++) {
                        if (temp[i].utilityTypeName == "Oil") {
                            this.oilRates.push(temp[i]);
                        }
                        if (temp[i].utilityTypeName == "Carbon") {
                            this.euaCertRates.push(temp[i]);
                        }

                        if (temp[i].utilityTypeName == "Equity") {
                            this.indicesRates.push(temp[i]);
                        }
                        if (temp[i].utilityTypeName != "Equity" && temp[i].utilityTypeName != "Carbon" && temp[i].utilityTypeName != "Oil") {
                            this.otherRates.push(temp[i]);
                        }
                    }

             
                });
            },

        }

    });
</script>
<style>
    #fxMarketGrid.e-grid .e-gridheader {
        border-bottom-style: solid;
        border-bottom-width: 0px;
        border-top-style: solid;
        border-top-width: 0px;
    }
    #fxMarketGrid.e-grid {
        border-style: none;
        border-radius: 0px;

    }

    .fx-price-padding {
        padding-top: 30px;
    }
    .market-rowFx {
        display: flex;
        background-color: white;
        padding-top: 30px;
        height: 1055px;
        width: 31%;
        padding: 25px 14px 35px 30px;
    }
    .e-btn-group-fx {
        margin: 0px 6px 20px 6px;
       
    }
    .chartFx {
        margin: 0px 0px 0px 0px;
    }
    .control-sectionFXfuture {
        border: 1px solid lightgrey;
        border-radius: 5px;
        padding: 0px 10px 0px 0px;
        width: 100%;
    }
    #powerTitleFx {
        padding: 10px 20px 20px 10px;
    }
    .btn-category{
        width: auto!important;
    }
    .below-0 {
        color: #1a9470!important;
    }

    .above-0 {
        color: #f25c54!important;
    }

    .same-0 {
        color: #001c55!important;
    }
    #stockchartcontainer_stock_border {
        border: 0px solid rgb(221, 221, 221)!important;
    }
   .power-marketFx .e-grid.e-gridhover tr[role='row']:not(.e-editedrow):hover .e-rowcell:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell) {
        cursor: pointer;
    }
    .parentMarket {
        width: 100% !important;
    }
    .form-row-Fx {
        display: flex;
        margin: 0px -50px 0px 22px;
    }
    #btn-marketOil {
        border-radius: 4px 0px 0px 4px;
        width:100%;
    }
    #btn-marketEua {
        border-radius: 0px 0px 0px 0px;
        width: 100%;
    }
    #btn-marketFx {
        border-radius: 0px 0px 0px 0px;
        width: 100%;
    }
    #btn-marketInd {
        border-radius: 0px 0px 0px 0px;
        width: 100%;
    }
    #btn-marketOth {
        border-radius: 0px 4px 4px 0px;
        width: 100%;
    }
    .col-md-2Fxbtn{
        margin-left: -11px;
    }
    #fxMarketGrid_Export\ Data {
        background-color: #4d4d4d;
        border: 1px solid #4d4d4d;
    }
        #fxMarketGrid_Export\ Data .e-tbar-btn-text {
            color: #fff!important;
        }
    #fxMarketGrid_Export\ Data:hover {
        background-color: #5d5d5d;
        border-color: #575757;
        -webkit-box-shadow: none;
        box-shadow: none;
        color: #fff;
    }

    .__web-inspector-hide-shortcut__ {
        display: none !important;
    }
    .border-flagCur {
        height: 15px;
        width: 15px;
        border-radius: 8px;
    }
    .e-toolbar-right > div:nth-child(3) {
        display: none !important;
    }


</style>